import React from 'react'
import Layout from '../../Layout/Layout'
import FooterCalendar from '../../Layout/FooterCalendar'
import CourseSection1 from './CourseSection1'
import FooterNew from '../../Layout/FooterNew'
import CourseSection2 from './CourseSection2'
import CourseSection3 from './CourseSection3'
// import Ebooks from './Ebooks'

function CoursesBooks() {
  return (
    <div>
      <Layout/>
      {/* <CourseSection1/> */}
      {/* <CourseSection2/> */}
      <CourseSection3/>
      {/* <Ebooks/> */}
      {/* <FooterCalendar/> */}
      <FooterNew/>
    </div>

  )
}

export default CoursesBooks;
